<template>
    <div style="height:100%;width:100;padding: 20px;">
        <el-table :data="data" @selection-change="selectionChange" @row-click="hanldeRowClick"  @row-dblclick="hanldeRowDBClick" @row-contextmenu="hanldeRowContextmenu" :height="tableHeight" stripe style="width: 100%;" :size="tablesize">
            <slot name="default" />
        </el-table>
        <div v-if="count!==null" class="page-container-content-footer">
            <el-pagination class="page-container-content-footer-bar" :current-page="form._page" :page-size="form._size" :total="count" @size-change="handleSizeChange" @current-change="handlePageChange"  :page-sizes="[5,10,15,20,30,50,100,200,300,400]" layout="total, sizes, prev, pager, next, jumper"/>
        </div>
    </div>
</template>
<script>
export default {
    name: "basic-table",
    props: {
		api       : {type: String ,default:''},
		search    : {type: Object ,default: ()=>{return {}}},
        tablesize : {type: String ,default:''},
    },
    data(){
        return {
            tableHeight:500,
			data: [],
			form: {
				_page: 1,
				_size: 20,
			},
			count: 0,
        }
    },
	mounted() {
		this.form = Object.assign({}, this.form, this.search);
		this.LoadDatas();
	},
    updated(){
        this.$nextTick().then(()=>{
            this.tableHeight = this.total===null?(this.$el.offsetHeight):(this.$el.offsetHeight - 70);
        });
    },
    methods: {
		/**
		 * 获取数据列表
		 * @param page 分页-当前页
		 * @param limit 分页-每页数量
		 * **/
		LoadDatas(page,limit){
		    page && (this.form._page = page),limit && (this.form._size = limit);
		    this.$get(this.api, this.form).then(res=>
		    {   
		        this.data  = res.data;
				this.count = res.extra.pageInfo.count;
		    }).catch(err=>{
		        this.$warning(err);
		    });
		},
		selectionChange(selection){
			this.$emit("selection-change", selection);
		},
        hanldeRowClick(row, column, event){
            this.$emit("row-click", {row, column, event});
        },
        hanldeRowDBClick(row, column, event){
            this.$emit("row-dbclick", {row, column, event});
        },
        hanldeRowContextmenu(row, column, event){
            this.$emit("row-context", {row, column, event});
        },
        handleSizeChange(val) {
			this.LoadDatas(this.form._page, val);
        },
        handlePageChange(val) {
			this.LoadDatas(val,this.form._size);
        },
		sortChange(e){
			this.$emit("sortChange", e);
		},
    },
}
</script>
<style lang="scss" scoped>
.page-container-content-footer{
    // position: fixed;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // height: 44px;
    background-color: rgb(255, 255, 255);
    .page-container-content-footer-bar{
        float: right;
        font-size: 14px !important;
        margin: 5px 100px 0px 0px;
    }
}

::v-deep .el-table {
	border-radius: 5px;
}
::v-deep .el-table th {
	text-align: center;
	background-color: #e9f2ff !important;
	color: #55565a;
	font-weight: bold;
}
</style>